// export const BASE_URL_API = 'https://cors-anywhere.herokuapp.com/https://sm.lokaci.com/andromeda/apis/';
export const BASE_URL_API = 'https://sm.lokaci.com/andromeda/apis/';
// export const BASE_URL_API = 'https://sm-test.lokaci.com/andromeda/apis/';